let headerMenu = document.querySelector(".header__inline-menu");
let items = headerMenu.querySelectorAll("details");

for (const item of items) {
    let subMenu = item.querySelector("ul");
    if (subMenu) {
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
        });

        item.addEventListener("mouseleave", () => {
            setTimeout(() => {
                if (!subMenu.matches(":hover")) {
                    item.removeAttribute("open");
                }
            }, 100); // Adjust the delay if needed
        });

        subMenu.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
        });

        subMenu.addEventListener("mouseleave", () => {
            setTimeout(() => {
                if (!item.matches(":hover")) {
                    item.removeAttribute("open");
                }
            }, 100); // Adjust the delay if needed
        });
    }
}
